export const isRecord = (obj: unknown): obj is Record<string, string | null> =>
  typeof obj === "object" && obj !== null && Object.values(obj).every((e) => typeof e === "string" || e === null);
